import { Component, OnInit } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import {
  FormControl,
  FormGroup,
  Validators,
  FormBuilder,
} from '@angular/forms';
import { ProjectsService } from '@/app/services/projects/projects.service';
import { NgToastService } from 'ng-angular-popup';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-contracts',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './contracts.component.html',
  styleUrls: ['./contracts.component.css'],
})
export class ContractsComponent implements OnInit {
  form: FormGroup;
  showFileError = false;
  uploadedFiles: { file: File; preview: string }[] = [];

  constructor(
    private fb: FormBuilder,
    private projectsService: ProjectsService,
    private toast: NgToastService
  ) {
    this.form = this.fb.group({
      contractTitle: [''],
      contractDescription: ['', Validators.required],
      contractFile: [null],
      summary: ['', Validators.required],
    });
  }

  ngOnInit() {
    this.form = new FormGroup({
      contractTitle: new FormControl(''),
      contractDescription: new FormControl('', [Validators.required]),
      contractFile: new FormControl(''),
      summary: new FormControl('', [Validators.required]),
    });
  }

  // Handle file upload
  onFileUpload(event: any) {
    const files: File[] = event.target.files;
    for (const file of files) {
      const fileReader = new FileReader();
      fileReader.onload = () => {
        const preview = fileReader.result as string;
        this.uploadedFiles.push({ file, preview });
      };
      fileReader.readAsDataURL(file); // Convert file to base64 preview
    }

    if (files.length > 0) {
      this.form.get('contractTitle')?.setValidators([Validators.required]);
      this.form.get('contractTitle')?.updateValueAndValidity();
    } else {
      this.form.get('contractTitle')?.clearValidators();
      this.form.get('contractTitle')?.updateValueAndValidity();
    }
  }

  removeFile(index: number) {
    this.uploadedFiles.splice(index, 1); // Remove the file at the given index
  }

  // Handle form submission
  onSubmit() {
    this.form.markAllAsTouched();
    if (this.form.valid) {
      const formData = new FormData();
      formData.append('contractTitle', this.form.get('contractTitle')?.value);
      formData.append(
        'contractDescription',
        this.form.get('contractDescription')?.value
      );
      formData.append('summary', this.form.get('summary')?.value);

      for (const fileObj of this.uploadedFiles) {
        formData.append('contractFiles', fileObj.file); // Append all uploaded files
      }

      this.projectsService.addProjectContract(formData).subscribe({
        next: () => {
          this.toast.success(
            'Project contract added successfully',
            'SUCCESS',
            4000
          );
          this.form.reset();
          this.uploadedFiles = []; // Clear files after submission
        },
        error: (error: any) => {
          console.log(error);
          
          this.toast.danger('Failed to add contract', 'DANGER', 4000);
        },
      });
    }
  }
}
